import { phoneNumberConstants ,phoneNumberAssignedConstants,phoneNumberCancelledConstants,phoneNumberPortConstants,editphoneNumberConstants,phoneNumberDeletedConstants} from '../Constants';
import { adminUsersServices } from '../Services';

export const phoneNumberUsersActions = {
    searchPhoneNumber,
    searchPhoneNumberAssigned,
    searchPhoneNumberCancelled,
    searchPhoneNumberPort,
    editPhoneNumber,
    searchPhoneNumberDeleted
};

function searchPhoneNumber(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: phoneNumberConstants.SEARCH_PHONENUMBER_REQUEST,
            data: null
        }));
        adminUsersServices.searchPhoneNumber(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: phoneNumberConstants.SEARCH_PHONENUMBER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: phoneNumberConstants.SEARCH_PHONENUMBER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: phoneNumberConstants.SEARCH_PHONENUMBER_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function searchPhoneNumberAssigned(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: phoneNumberAssignedConstants.SEARCH_PHONENUMBERASSIGNED_REQUEST,
            data: null
        }));
        adminUsersServices.searchPhoneNumberAssigned(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: phoneNumberAssignedConstants.SEARCH_PHONENUMBERASSIGNED_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: phoneNumberAssignedConstants.SEARCH_PHONENUMBERASSIGNED_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: phoneNumberAssignedConstants.SEARCH_PHONENUMBERASSIGNED_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function searchPhoneNumberDeleted(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: phoneNumberDeletedConstants.SEARCH_PHONENUMBERDELETED_REQUEST,
            data: null
        }));
        adminUsersServices.searchPhoneNumberAssigned(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: phoneNumberDeletedConstants.SEARCH_PHONENUMBERDELETED_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: phoneNumberDeletedConstants.SEARCH_PHONENUMBERDELETED_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: phoneNumberDeletedConstants.SEARCH_PHONENUMBERDELETED_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function searchPhoneNumberCancelled(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: phoneNumberCancelledConstants.SEARCH_PHONENUMBERCANCELLED_REQUEST,
            data: null
        }));
        adminUsersServices.searchPhoneNumberCancelled(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: phoneNumberCancelledConstants.SEARCH_PHONENUMBERCANCELLED_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: phoneNumberCancelledConstants.SEARCH_PHONENUMBERCANCELLED_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: phoneNumberCancelledConstants.SEARCH_PHONENUMBERCANCELLED_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function searchPhoneNumberPort(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: phoneNumberPortConstants.SEARCH_PHONENUMBERPORT_REQUEST,
            data: null
        }));
        adminUsersServices.searchPhoneNumberPort(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: phoneNumberPortConstants.SEARCH_PHONENUMBERPORT_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: phoneNumberPortConstants.SEARCH_PHONENUMBERPORT_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: phoneNumberPortConstants.SEARCH_PHONENUMBERPORT_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function editPhoneNumber(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: editphoneNumberConstants.EDIT_PHONENUMBER_REQUEST,
            data: null
        }));
        adminUsersServices.editPhoneNumber(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editphoneNumberConstants.EDIT_PHONENUMBER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editphoneNumberConstants.EDIT_PHONENUMBER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editphoneNumberConstants.EDIT_PHONENUMBER_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}